export const ADD_NEWS_LETTER_SUCCESS = "ADD_NEWS_LETTER_SUCCESS";
export const CREATE_NEWS_LETTER_SUCCESS = "CREATE_NEWS_LETTER_SUCCESS";
export const LIST_ALL_NEWS_LETTERS_REQUEST = "LIST_ALL_NEWS_LETTERS_REQUEST";
export const LIST_ALL_NEWS_LETTERS_SUCCESS = "LIST_ALL_NEWS_LETTERS_REQUEST_SUCCESS";
export const LIST_ALL_NEWS_LETTERS_FAILURE = "LIST_ALL_NEWS_LETTERS_FAILURE";
export const UPDATE_NEWS_LETTER_SUCCESS = "UPDATE_NEWS_LETTER_SUCCESS";
export const DELETE_NEWS_LETTER_SUCCESS = "DELETE_NEWS_LETTER_SUCCESS";
